import axios from 'axios'
import React, { useEffect, useState } from 'react'
// import Calendar from 'react-calendar'
// import { Link } from 'react-router-dom'
import authService from '../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1,
  TitlePage2,
  //TitlePage3
} from '../Components/Main'
import ProfileDireita from '../Components/ProfileDireita'
import { NavDireita } from '../Components/SideBar-right/SideBarDireita'
import SidebarMobile from '../Components/SideBar-right/SidebarMobile'
import '../styles/pages/FormularioCadastro.css'
//const uuidv4 = require('uuid/v4')

function FormularioCadastro() {
  const uuidv4 = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(16) + '-' + Math.random().toString(16).slice(2);

  var user = authService.getCurrentUser()
  let newDate = new Date()
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          '/api/v1/unidade/' +
          sessionStorage.IdUnidade
      )
      .then(response => {
        setCampos(response.data[0])
        sessionStorage.IdUnidade = response.data[0]['IdUnidade']
        sessionStorage.uniRazaoSocial = response.data[0]['uniRazaoSocial']
        sessionStorage.uniSubUnidades = response.data[0]['uniSubUnidades']
      })
  }, [])

  const [campos, setCampos] = useState({
    IdUnidade: '',
    IdEmpresa: user[0].IdEmpresa,
    uniNome: '',
    uniRazaoSocial: '',
    uniCNPJ: '',
    uniLogo: '',
    uniEndereco: '',
    uniStatus: 1,
    uniObservacoes: '',
    uniCriadoPor: user[0].pesEmail,
    uniCriadoEm: newDate,
    uniAlteradoPor: user[0].pesEmail,
    uniAlteradoEm: newDate,
    uniCodigoGUID: uuidv4,
    uniSubUnidades: 0
  })

  const [camposLocal, setCamposLocal] = useState({
    IdLocalArea: '',
    IdEmpresa: user[0].IdEmpresa,
    IdUnidade: sessionStorage.IdUnidade,
    IdGerencia: 0,
    locDescricao: '',
    locReferencia: '',
    locStatus: 1,
    locObservacoes: '',
    locCriadoPor: user[0].pesEmail,
    locCriadoEm: newDate,
    locAlteradoPor: user[0].pesEmail,
    locAlteradoEm: newDate,
    locCodigoGUID: uuidv4
  })

console.log(campos)

  function handleInputChange(event: any) {
    const { name, type, checked, value } = event.target
    const newValue = name === 'uniSubUnidades' ? (checked ? 1 : 0) : value
    setCampos({ ...campos, [name]: newValue })
  }
  function handleFormSubmit(event: any) {
    event.preventDefault()
    //se a unidade não terá sub unidades
    if (campos.uniSubUnidades === 0) {
      //avisa e aguarda ação do usuário
      if (window.confirm('Essa Unidade não permitirá Cadastrar novas Sub-Unidades (Locais). \n Deseja continuar e Salvar?')) {
        axios
          .put(
            process.env.REACT_APP_API_URL + '/api/v1/unidade/' + campos.IdUnidade,
            campos
          )
          .then(response => {
            //precisa validar se a unidade já tem uma sub e cadastra com os mesmos dados
            axios
              .get(
                process.env.REACT_APP_API_URL +
                '/api/v1/area/list/' +
                campos.IdEmpresa +
                '/' +
                campos.IdUnidade
              ).then(resp => {
                //valida se não tiver local cadastra o primeiro
                if (!resp.data[0]) {
                  //alert('sem local')
                  camposLocal.locDescricao = campos.uniNome
                  setCamposLocal(camposLocal)
                  console.log(camposLocal)
                  axios
                    .post(process.env.REACT_APP_API_URL + '/api/v1/area',
                      camposLocal)
                    .then(respLoc => {
                      alert(response.data.message + "\n \n" + respLoc.data.message)
                      window.location.reload()
                    })
                  //alert(response.data.message + "\n \n" + resp.data.message)
                }
                else {
                  alert(response.data.message)
                  window.location.reload()
                }
              })
            //window.location.reload()
          })
      }
    }
    //terá novas unidades
    else {
      axios
        .put(
          process.env.REACT_APP_API_URL + '/api/v1/unidade/' + campos.IdUnidade,
          campos
        )
        .then(response => {
          alert(response.data.message)
          window.location.reload()
        })
    }
  }
  return (
    <div className="displayInteract">
      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" />
        </div>

        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage1>DADOS CADASTRAIS</TitlePage1>
            <TitlePage2>{campos.uniRazaoSocial}</TitlePage2>
            {/* <TitlePage3>Dados Cadastrais:</TitlePage3> */}
          </TitleOfPage>
        </div>
        <form className="tabelaPadraoCad" onSubmit={handleFormSubmit}>
          <p className="titulo1">Nome Fantasia</p>
          <input
            className="fcadastro1"
            type="text"
            autoComplete="nope"
            id="fname"
            onChange={handleInputChange}
            name="uniNome"
            defaultValue={campos.uniNome}
          />
          <p className="titulo2">CNPJ</p>
          <input
            className="fcadastro2"
            type="text"
            autoComplete="nope"
            id="fname"
            onChange={handleInputChange}
            name="uniCNPJ"
            defaultValue={campos.uniCNPJ}
          />
          <p className="titulo3">Status</p>
          <select
            className="fcadastro3"
            typeof="text"
            onChange={handleInputChange}
            name="uniStatus"
            defaultValue={campos.uniStatus}
          >
            <option value="">Selecione o Status da Empresa:</option>
            <option value="0" selected={campos.uniStatus === 0}>
              Inativo
            </option>
            <option value="1" selected={campos.uniStatus === 1}>
              Ativo
            </option>
          </select>

          <p className="titulo4">Possui sub-unidades (Locais)?</p>
          <select
            className="fcadastro4"
            typeof="text"
            onChange={handleInputChange}
            name="uniSubUnidades"
            defaultValue={campos.uniSubUnidades}
          >
            <option value="0" selected={campos.uniSubUnidades === 0}>
              Não
            </option>
            <option value="1" selected={campos.uniSubUnidades === 1}>
              Sim
            </option>
          </select>

          <p className="titulo7">Razão Social</p>
          <input
            className="fcadastro7"
            type="text"
            autoComplete="nope"
            id="fname"
            onChange={handleInputChange}
            name="uniRazaoSocial"
            defaultValue={campos.uniRazaoSocial}
          />
          <p className="titulo8">Endereço</p>
          <input
            className="fcadastro8"
            type="text"
            autoComplete="nope"
            id="fname"
            onChange={handleInputChange}
            name="uniEndereco"
            defaultValue={campos.uniEndereco}
          />
          <p className="titulo9">Observações</p>
          <input
            className="fcadastro9"
            type="text"
            autoComplete="nope"
            id="fname"
            onChange={handleInputChange}
            name="uniObservacoes"
            defaultValue={campos.uniObservacoes}
          />

          {/* <p className="titulo4">
          <input 
            name="uniSubUnidades"
            type="checkbox"
            defaultChecked={campos.uniSubUnidades === 1 ? false : true}
            onChange={handleInputChange}
          />
          <span>Possui sub-unidades?</span>
          </p>  */}
          
              

          <button className="buttonSave" typeof="submit">
            Salvar
          </button>
        </form>
      </ContainerPage>

      <nav className="esconderFiltro">
        <ProfileDireita />
        <NavDireita />

        {user[0].gruDescricao === 'Humanit' ? (
          <SidebarMobile />
        ) : user[0].gruDescricao === 'Administrativo' ? (
          <SidebarMobile />
        ) : (
          <div></div>
        )}
      </nav>
    </div>
  )
}

export default FormularioCadastro
